/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { fetchData, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr'

const VehicleDetailsHeader: React.FC = () => {
  const t = Tr()
  const location = useLocation();
  const vehicleId = (location.state as any)?.vehicleId || '';
  const [vehicleDetails, setVehicleDetails] = useState([]);

  // vehicle Details api call
  const vehicleDetailsApiCall=async()=>{
        
    var param:any={
        vehicleId:vehicleId,
    }
    var response:any=await fetchData("public/vehicleDetail",param)
    
    if(response.status=="200")
    {
        setVehicleDetails(response.data);
    }
    else
    {
        toasterrormsg(response.message)
    }
  }
  useEffect(()=>{
    vehicleDetailsApiCall()
  },[])
  return (
    <>
    {
      vehicleDetails.map((vehicle:any,index:any)=>{
        
        var imageUrl = '';
        var totalImage = '';
        if(vehicle['images'].length != 0){
          imageUrl = vehicle['images'][0].mediaPath;
          totalImage = '+'+(vehicle['images'].length-1);
        }else{
          imageUrl = toAbsoluteUrl("/media/avatars/300-1.jpg");
          totalImage = '';
        }
        return (
          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {
                      totalImage ? (
                        <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 d-flex justify-content-center align-items-center'>{totalImage}</div>
                      ):('')
                    }
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {vehicle['en_name']}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{vehicle['seatsDetail'].length != 0 ? vehicle['seatsDetail'][0]['seats'] : '0'}</div>
                          </div>

                          <div className='fw-bold fs-6 text-gray-400'>{t('No. Of Seats')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/vehicleoverview/' && 'active')
                      }
                      to='../vehicleoverview/'
                      state={{vehicleId:vehicleId}}
                    >
                      {t('All Details')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
      })
    }
    </>
  )
}

export {VehicleDetailsHeader}
